import React from 'react'
import {Checkbox, Icon} from '@fluentui/react';
import LevelList from "./LevelList";
import {Divider} from "@material-ui/core";
import Api from '../../services/Api'
import axios from 'axios';

class DropdownTree extends React.Component {
    constructor() {
        super();
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.state = {
            allTreeItems: [],
            dropdownExpanded: false,
            possibilities: null,
            dropHover: false,
            selection: []
        }
    }

    fitPossibilities(posts) {
        this.setState({allTreeItems: posts}, () => this.firstLevelItems())
    }

    firstLevelItems() {
        let items = this.state.allTreeItems.filter(x => x.parentKey === 'ABB' || x.parentKey === null);
        this.setState({possibilities: items})
    }

    componentWillUnmount() {
        this.axiosCancelSource.cancel();

        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.axiosCancelSource = axios.CancelToken.source()
        const includeCrossOrg = this.props.includeCrossOrg ? '&includeCrossOrg=true' : ''

        Api.get(this.props.address + 'all' + includeCrossOrg, {
            cancelToken: this.axiosCancelSource.token
        })
        .then(res => res.data)
        .then(posts => {
                this.fitPossibilities(posts);
            }
        )
        .catch(err => {});
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({dropdownExpanded: false});
        }
    }

    isAllSelected() {
        return this.state.selection.length === 0
    }

    selectAll() {
        if (this.state.selection.length > 0) {
            this.setState({selection: []}, () => this.updateFilters())
        }
    }

    select(item) {
        let selection = this.state.selection;
        if (!this.props.multiselect) {
            selection = [];
            selection.push(item);
        }
        if (this.props.multiselect) {
            if (selection.filter(member => member.key === item.key).length !== 0) {
                selection = selection.filter(x => x.key !== item.key)
            } else if (selection.filter(member => member.key === item.parentKey).length !== 0) {
                selection = this.handleDeselection(item, selection);
            } else {
                selection = this.handleSelection(item, selection);
            }
        }
        this.setState({selection: selection}, () => this.updateFilters());
    }

    handleSelection(item, selection) {
        let onLevel = this.state.allTreeItems.filter(x => x.parentKey === item.parentKey)
        let selectedOnLevel = this.state.selection.filter(x => x.parentKey === item.parentKey);

        if (onLevel.length === selectedOnLevel.length + 1) {
            if(item.parentKey ==='ABB')
            {
                selection = []
            }
            else {
                let selectedItem = this.state.allTreeItems.filter(x => x.key === item.parentKey)[0];
                selection = this.deselectBelowChoice(selectedItem);
                selection.push(selectedItem);
            }
        }
        else {
            selection = this.deselectBelowChoice(item);
            selection.push(item);
        }
        return selection;
    }

    handleDeselection(item, selection) {
        const toSelect = this.state.allTreeItems.filter(x => x.parentKey === item.parentKey && x.key !== item.key);
        let toDeselect = [];
        toDeselect = this.itemPath(item.parentKey, toDeselect);
        selection = this.removeFormSelection(toDeselect, selection);
        toSelect.map(x=> selection.push(x));
        return selection;
    }

    itemPath(parentKey, path) {
        const allItems = this.state.allTreeItems;
        if (parentKey !== 'ABB') {
            const parent = allItems.filter(x => x.key === parentKey)[0];
            path.push(parent);
            this.itemPath(parent.parentKey, path)
        }
        return path;
    }

    deselectBelowChoice(item) {
        const selection = this.state.selection;
        let toDeselect = [];
        selection.forEach(x => {
            this.belongsToSelection(item, x, toDeselect)
        });
        return this.removeFormSelection(toDeselect,selection);
    }

    belongsToSelection(item, candidate, toDeselect) {
        const allItems = this.state.allTreeItems;
        if (candidate.parentKey !== 'ABB' && candidate.parentKey) {
            if (item.key === candidate.parentKey) {
                toDeselect.push(candidate);
                return;
            }
            const parent = allItems.filter(x => x.key === candidate.parentKey)[0];
            this.belongsToSelection(item, parent, toDeselect)
        }
    }

    removeFormSelection(toRemove,selection) {
        selection = selection.filter(function (el) {
            return toRemove.indexOf(el) < 0;
        });
        return selection;
    }

    updateFilters() {
        const values = this.state.selection.map(x => x.key).join(':');
        this.props.onChange(this.props.fieldName, values);
    }

    setHover() {
        this.setState({dropHover: !this.state.dropHover});
    }

    expandDropdown() {
        this.setState({dropdownExpanded: !this.state.dropdownExpanded});
    }

    setFieldText() {
        if (this.state.selection.length === 0) {
            return 'All'
        }
        let value = this.state.selection.map(x => x.key === 'Cross' || this.props.hideKey ? x.value : `${x.key} - ${x.value}`).join(', ');

        if (value.length > 27) {
            value = value.substring(0, 27) + '...';
        }
        return value;
    }


    render() {
        const address = this.props.address;
        const style = !this.state.dropHover ? dropStyle : dropStyleHover;
        const firstLevel = 
            <div style={{position: 'absolute', zIndex: 1}}>
                {   this.state.possibilities &&
                    <LevelList
                        childMark={false}
                        items={this.state.possibilities}
                        selection={this.state.selection}
                        address={address}
                        select={this.select.bind(this)}
                        allTreeItems={this.state.allTreeItems}
                        hideKey={this.props.hideKey}
                    />
                }
                <Divider/>
                <div style={this.isAllSelected() ? selectAllSelectedStyle : selectAllStyle}>
                    <Checkbox checked={this.state.selection.length === 0} onChange={this.selectAll.bind(this)} label='All'/>
                </div>
            </div>
        return (
            <div ref={this.setWrapperRef} style={{marginTop: '5px'}}>
                <div style={{fontSize: 14, marginBottom: '6px'}}>{this.props.label}</div>
                <div style={style} onClick={this.expandDropdown.bind(this)} onMouseEnter={this.setHover.bind(this)}
                     onMouseLeave={this.setHover.bind(this)}>
                    <span style={initialTextStyle}> {this.setFieldText()}</span>
                    <Icon style={iconClass} iconName="ChevronDown"/>
                </div>
                {
                    this.state.dropdownExpanded ? <div>
                        {firstLevel}
                    </div> : null
                }
            </div>
        );
    }
}

const initialTextStyle = {
    marginLeft: '5px',
    fontSize: 14,
    color: 'black',
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: '30px',
    backgroundColor: 'white'
}

const selectAllSelectedStyle = {
    height: '20px',
    width: '222px',
    marginBottom: '3px',
    padding: '4px 4px 4px 4px',
    margin: '0 auto',
    left: 0,
    right: 0,
    backgroundColor: 'rgb(237, 235, 233)',
    boxShadow: 'rgba(0, 0, 0, 0.133) 0px 3.2px 7.2px 0px, rgba(0, 0, 0, 0.11) 0px 0.6px 1.8px 0px'
}

const selectAllStyle = {
    height: '20px',
    width: '222px',
    marginBottom: '3px',
    padding: '4px 4px 4px 4px',
    margin: '0 auto',
    left: 0,
    right: 0,
    backgroundColor: 'white',
    boxShadow: 'rgba(0, 0, 0, 0.133) 0px 3.2px 7.2px 0px, rgba(0, 0, 0, 0.11) 0px 0.6px 1.8px 0px'
}
const iconClass = {
    float: 'right',
    fontSize: 12,
    margin: '9px 4px'
};

const dropStyle = {
    border: 'solid 1px rgb(96, 94, 92)',
    color: 'black',
    borderRadius: '2px',
    backgroundColor: 'white',
    width: '228px',
    height: '30px'
}

const dropStyleHover = {
    border: 'solid 1px black',
    borderRadius: '2px',
    backgroundColor: 'white',
    width: '228px',
    height: '30px',
    cursor: 'pointer'
}
export default DropdownTree


// WEBPACK FOOTER //
// ./src/components/CustomComponents/DropdownTree.js